module.exports = __webpack_public_path__ + "img/cp-1.11df978f.png";